import React, {Component} from 'react';
import CompanyInformation from "../../components/AccountInformation/CompanyInformation";
import AccountInfo from "../../components/AccountInformation/AccountInformation";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import validator from "validator";
import {updateAccount} from "../../store/actions/user";
import Modal from 'react-modal';
import ChangePassword from "../../components/popups/ChangePassword";
import {toast} from "react-toastify";
import {getWarehouses} from "../../store/actions/warehouse";
import defaultImage from "../../assets/img/default-img.png";

Modal.setAppElement('#root');

class AccountInformation extends Component {
  constructor(props) {
    super(props);
    this.handleUserInput = this.handleUserInput.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.state = {
      modalIsOpen: false,
      companyName: {
        value: this.props.user.company ? this.props.user.company.name : '',
        isValid: !validator.isEmpty(this.props.user.company ? this.props.user.company.name : ''),
        errorMessage: '',
        touched: false
      },
      firstName: {
        value: this.props.user.first_name,
        isValid: !validator.isEmpty(this.props.user.first_name),
        errorMessage: '',
        touched: false
      },
      lastName: {
        value: this.props.user.last_name,
        isValid: !validator.isEmpty(this.props.user.last_name),
        errorMessage: '',
        touched: false
      },
      email: {
        value: this.props.user.email,
        isValid: validator.isEmail(this.props.user.email),
        errorMessage: '',
        touched: false
      },
      image: this.props.user.company ? this.props.user.company.image : defaultImage,
      formValid: true
    };
  }

  componentWillMount() {
    if (this.props.user.role === 'general') {
      this.props.getWarehouses();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.accountUpdated.status === 400) {
      this.setState({
        email: {
          ...this.state.email,
          isValid: false,
          errorMessage: 'This email already exists'
        }
      });
    }
  }

  openModal() {
    this.setState({
      modalIsOpen: true
    });
  }

  closeModal(args = false) {
    this.setState({
      modalIsOpen: false
    });
    if (typeof args === 'boolean') {
      toast.success('Password successfully changed.', {
        position: toast.POSITION.TOP_RIGHT,
        className: ''
      });
    }
  }

  handleUserInput(ev) {
    const fieldName = ev.target.name;
    const value = ev.target.value;

    this.setState({
      [fieldName]: {
        ...this.state[fieldName],
        value
      }
    }, () => this.validateField(fieldName, value));
  }

  validateField(fieldName, value) {
    let companyNameValid = this.state.companyName.isValid;
    let companyNameErrorMessage = this.state.companyName.errorMessage;
    let firstNameValid = this.state.firstName.isValid;
    let firstNameErrorMessage = this.state.firstName.errorMessage;
    let lastNameValid = this.state.lastName.isValid;
    let lastNameErrorMessage = this.state.lastName.errorMessage;
    let emailValid = this.state.email.isValid;
    let emailErrorMessages = this.state.email.errorMessage;

    let isValid = false;
    let errorMessage = '';

    switch (fieldName) {
      case 'companyName':
        companyNameValid = !validator.isEmpty(value);
        companyNameErrorMessage = 'Company Name is required.';
        isValid = companyNameValid;
        errorMessage = companyNameErrorMessage;
        break;
      case 'firstName':
        firstNameValid = !validator.isEmpty(value);
        firstNameErrorMessage = 'First Name is required.';
        isValid = firstNameValid;
        errorMessage = firstNameErrorMessage;
        break;
      case 'lastName':
        lastNameValid = !validator.isEmpty(value);
        lastNameErrorMessage = 'First Name is required.';
        isValid = lastNameValid;
        errorMessage = lastNameErrorMessage;
        break;
      case 'email':
        emailValid = validator.isEmail(value);
        emailErrorMessages = 'Entered email address is wrong.';
        isValid = emailValid;
        errorMessage = emailErrorMessages;
        break;
      default:
        break;
    }

    this.setState({
      [fieldName]: {
        ...this.state[fieldName],
        isValid,
        errorMessage
      }
    }, this.validateForm);
  }

  validateForm() {
    const {companyName, firstName, lastName, email} = this.state;

    this.setState({
      formValid: companyName.isValid && firstName.isValid && lastName.isValid && email.isValid
    });
  }

  handleInputBlur(ev) {
    const name = ev.target.name;

    this.setState({
      [name]: {
        ...this.state[name],
        touched: !!ev.target.value
      }
    });
  }

  handleImageChange(ev) {
    const file = ev.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      this.setState({
        image: reader.result
      }); // TODO remove callback
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  }

  onSubmit(ev) {
    ev.preventDefault();

    if (this.state.formValid) {
      const {companyName, image, firstName, lastName, email} = this.state;
      const companyData = {
        name: companyName.value
      };

      if (image.match(/^data:image/)) {
        companyData.image = image;
      }

      const userData = {
        first_name: firstName.value,
        last_name: lastName.value,
        email: email.value
      };

      this.props.updateAccount(this.props.user.id, this.props.user.company.id, companyData, userData);
    }
  }

  render() {
    return (
        <main>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <form className="card" onSubmit={this.onSubmit.bind(this)}>
                  <CompanyInformation
                      companyName={this.state.companyName}
                      handleUserInput={this.handleUserInput}
                      handleInputBlur={this.handleInputBlur}
                      image={this.state.image}
                      onImageSelect={this.handleImageChange.bind(this)}
                      user={this.props.user}
                      warehouses={this.props.warehouses}
                  />
                  <AccountInfo
                      openModal={this.openModal.bind(this)}
                      firstName={this.state.firstName}
                      lastName={this.state.lastName}
                      onFieldChange={this.handleUserInput}
                      onFieldBlur={this.handleInputBlur}
                      email={this.state.email}
                  />
                  <div className="card-footer text-right">
                    <input type="submit" className="btn btn-lg btn-primary" value="Save"
                           disabled={!this.state.formValid}/>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <Modal isOpen={this.state.modalIsOpen} onRequestClose={this.closeModal}>
            <ChangePassword closeModal={this.closeModal}/>
          </Modal>
        </main>
    );
  }
}

AccountInformation.propTypes = {
  user: PropTypes.object.isRequired,
  updateAccount: PropTypes.func.isRequired,
  accountUpdated: PropTypes.any,
  getWarehouses: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  user: state.auth.user,
  accountUpdated: state.user.accountUpdated,
  warehouses: state.warehouse.warehouses
});

const mapDispatchToProps = dispatch => ({
  updateAccount: (userId, companyId, companyData, userData) => dispatch(updateAccount(userId, companyId, companyData, userData)),
  getWarehouses: () => dispatch(getWarehouses())
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountInformation);



// WEBPACK FOOTER //
// ./src/containers/AccountInformation/AccountInformation.jsx